import React from 'react';
import { Button, Icon, Toolbar } from '@fanadise/common-ui';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/solid';
import { Translate } from '@fanadise/common-logic';
import CategoriesList from 'components/categories/CategoriesList';

const CategoriesRouteList: React.FC = () => (
  <>
    <Toolbar
      mb="8"
      title={<Translate id="categories:list:title" />}
      actions={
        <Link to="add">
          <Button tag="span" icon={<Icon icon={PlusIcon} />}>
            <Translate id="categories:add:title" />
          </Button>
        </Link>
      }
    />

    <CategoriesList />
  </>
);

export default CategoriesRouteList;
